export default "__VITE_ASSET__DIgmoqBI__"